import {
    ActionTypes
} from "../type";

const initialState = {
    investigation_id: null,
    labDeptId: null
}

export const investigationReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.INVESTIGATION_DETAILS:
            return {
                ...state, investigation_id: action.payload
        }
        case ActionTypes.SET_LAB_DEPT_ID:
            return {
                ...state,
                labDeptId: action.payload
        }
        default:
            return state;
    }
}